// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__14TTK","requiredAsterisk":"Info_requiredAsterisk__2hF5A"};